var moduleMap = {
	"./FederatedApp": function() {
		return Promise.all([__webpack_require__.e(4669), __webpack_require__.e(3677), __webpack_require__.e(1899), __webpack_require__.e(7100), __webpack_require__.e(1243), __webpack_require__.e(5334), __webpack_require__.e(1556), __webpack_require__.e(9090), __webpack_require__.e(4914), __webpack_require__.e(4442), __webpack_require__.e(7642), __webpack_require__.e(5003), __webpack_require__.e(6672), __webpack_require__.e(2079), __webpack_require__.e(4281), __webpack_require__.e(2877)]).then(function() { return function() { return (__webpack_require__(20729)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});